import { DatePattern } from "@/constants/common.constant";
import dayjs from "dayjs";

/**
 *
 * @param date
 * @param formatter
 * @returns "YYYY-MM-DD HH:mm:ss"形のDATE
 * @example dateFormat("2021-05-11T03:25:50.000Z") -> "2021-05-11 12:25:50"
 */
export function dateFormat(
  date: string | Date,
  formatter: string = DatePattern.DateTimePattern
) {
  return dayjs(date).format(formatter);
}
